import { render, staticRenderFns } from "./RealIntentions.vue?vue&type=template&id=5ef1aa99"
import script from "./RealIntentions.vue?vue&type=script&lang=js"
export * from "./RealIntentions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports